// Workflow field domain constants.

export const WORKFLOW_FIELD_SOURCE = {
  USER_INPUT: 'USER_INPUT',
  USER_ACTION: 'USER_ACTION',
  COMPUTED_FIELD: 'COMPUTED_FIELD',
  COMPUTED_VARS_MULTI: 'COMPUTED_VARS_MULTI',
};

export const WORKFLOW_FIELD_SOURCE_OPTIONS = [
  { label: 'User Input', value: WORKFLOW_FIELD_SOURCE.USER_INPUT },
  { label: 'User Action', value: WORKFLOW_FIELD_SOURCE.USER_ACTION },
  { label: 'Computed Field', value: WORKFLOW_FIELD_SOURCE.COMPUTED_FIELD },
  { label: 'Computed Variables (Multi)', value: WORKFLOW_FIELD_SOURCE.COMPUTED_VARS_MULTI },
];

/** Sources that share computed-field behaviour across the app. */
export const WORKFLOW_FIELD_COMPUTED_SOURCES = [
  WORKFLOW_FIELD_SOURCE.COMPUTED_FIELD,
  WORKFLOW_FIELD_SOURCE.COMPUTED_VARS_MULTI,
];

export const isComputedFieldSource = (source) =>
  WORKFLOW_FIELD_COMPUTED_SOURCES.includes(source);

/** Sources that should default Category to System. */
export const isSystemCategoryFieldSource = (source) =>
  isComputedFieldSource(source) || source === WORKFLOW_FIELD_SOURCE.USER_ACTION;

export const WORKFLOW_FIELD_CATEGORY = {
  WORKFLOW: 'WORKFLOW',
  SYSTEM: 'SYSTEM',
};

export const WORKFLOW_FIELD_DATA_TYPE = {
  USER_ACTION: 'USER_ACTION',
};

export const normalizeWorkflowFieldDataTypeCode = (dataType) => {
  if (!dataType) {
    return '';
  }

  const raw = String(dataType).toUpperCase();
  return raw.startsWith('FIELD_') ? raw.slice(6) : raw;
};

export const isUserActionDataType = (dataType) =>
  normalizeWorkflowFieldDataTypeCode(dataType) === WORKFLOW_FIELD_DATA_TYPE.USER_ACTION;

export const isComputedWorkflowField = (field) =>
  isComputedFieldSource(field?.source) || isComputedFieldSource(field?.raw?.source);

export const getWorkflowFieldSourceLabel = (source) => {
  const match = WORKFLOW_FIELD_SOURCE_OPTIONS.find((option) => option.value === source);
  return match?.label ?? source ?? '—';
};

// Data types that support an enumerated option list.
export const WORKFLOW_FIELD_OPTION_DATA_TYPES = ['STRING', 'BOOLEAN', 'NUMBER'];

/** Workflow editor field update drawer width (2x previous 420). */
export const WORKFLOW_FIELD_DRAWER_WIDTH = 840;

export const WORKFLOW_FIELD_HANDLER_ACTION = {
  UPDATE: 'UPDATE',
  DEASSOCIATE: 'DEASSOCIATE',
};

/** Sequence step used when reordering workflow field handlers (100, 200, …). */
export const WORKFLOW_HANDLER_SEQUENCE_STEP = 100;

/** Field-handler UI events from the UI_EVENTS enumeration. */
export const WORKFLOW_UI_EVENT = {
  ON_FOCUS: 'ON_FOCUS',
  ON_BLUR: 'ON_BLUR',
  ON_CLICK: 'ON_CLICK',
  ON_KEY_DOWN: 'ON_KEY_DOWN',
  ON_DB_CLICK: 'ON_DB_CLICK',
  ON_CHANGE: 'ON_CHANGE',
  ON_SELECT: 'ON_SELECT',
};

/** Value typing for execute_button_action result_info rows. */
export const HANDLER_RESULT_VALUE_TYPE = {
  FILE: 'FILE',
};

export const HANDLER_RESULT_FILE_FORMAT = {
  BASE64: 'BASE64',
};

export const COMPUTE_MATCHING_THRESHOLD_KEY = 'MATCHING_THRESHOLD';

export const COMPUTE_MATCHING_THRESHOLD_OPTIONS = [
  { label: '50%', value: 50 },
  { label: '70%', value: 70 },
  { label: '90%', value: 90 },
];

export const DEFAULT_COMPUTE_MATCHING_THRESHOLD = 80;

export function hasWorkflowFieldComputeHandler(field) {
  return Boolean(String(field?.compute_handler ?? field?.raw?.compute_handler ?? '').trim());
}

export function resolveWorkflowFieldVisibleFlag(field) {
  if (field?.visible_flag !== undefined && field?.visible_flag !== null) {
    return Boolean(field.visible_flag);
  }

  return !hasWorkflowFieldComputeHandler(field);
}

export function resolveDefaultAssociationVisibleFlag(field) {
  return !hasWorkflowFieldComputeHandler(field);
}

export function isWorkflowFieldVisibleInPreview(field) {
  return resolveWorkflowFieldVisibleFlag(field);
}
